import { useTranslation } from 'react-i18next'
import { useLocalizationConfig } from '@/hooks/useDateFormatter'
import { formatMonthYear } from '@/lib/date'

/**
 * EP-144: the billing period of a subscription invoice, as a month label
 * ("August 2026" / "สิงหาคม 2569") rather than a day.
 *
 * `period_from` is a DATE column, so it arrives as a bare `YYYY-MM-DD`.
 * `new Date('2026-08-01')` is UTC midnight, which renders as July 31st for any
 * account timezone west of UTC, so the Date is built from the string parts in
 * local time instead. The era follows the account's calendar setting and the
 * month name follows the UI language, never the browser locale.
 */
export function useBillingPeriodLabel() {
  const { i18n } = useTranslation('settings')
  const { calendar } = useLocalizationConfig()

  return (periodFrom: string | null | undefined) => {
    if (!periodFrom) return ''
    const [year, month, day] = periodFrom.split('-').map(Number)
    if (!year || !month) return ''
    const date = new Date(year, month - 1, day || 1)
    return formatMonthYear(date, { locale: i18n.language, calendar })
  }
}
